import React from 'react';
import './SpatialConfig.css';
import { isArrangementAvailable } from './productRules';

const SpatialConfig = ({ arrangement, onArrangementChange, selectedProduct }) => {
  // Check which arrangements are available for this product
  const individualAvailable = isArrangementAvailable(selectedProduct, 'individual');
  const groupedAvailable = isArrangementAvailable(selectedProduct, 'grouped');
  const customAvailable = isArrangementAvailable(selectedProduct, 'custom');
  
  // Check if any arrangement is available
  const anyArrangementAvailable = individualAvailable || groupedAvailable || customAvailable;
  
  // If no arrangement is available, don't render the component
  if (!anyArrangementAvailable) {
    return null;
  }

  return (
    <div className="spatial-config">
      <h3>Configurare așezare în spațiu</h3>
      
      <div className="arrangement-options">
        {individualAvailable && (
          <label className="arrangement-option">
            <input 
              type="radio" 
              name="arrangement" 
              value="individual" 
              checked={arrangement === 'individual'}
              onChange={() => onArrangementChange('individual')}
            />
            <span className="option-text">Elemente individuale</span>
          </label>
        )}
        
        {groupedAvailable && (
          <label className="arrangement-option">
            <input 
              type="radio" 
              name="arrangement" 
              value="grouped" 
              checked={arrangement === 'grouped'}
              onChange={() => onArrangementChange('grouped')}
            />
            <span className="option-text">Elemente grupate</span>
          </label>
        )}
        
        {customAvailable && (
          <label className="arrangement-option">
            <input 
              type="radio" 
              name="arrangement" 
              value="custom" 
              checked={arrangement === 'custom'}
              onChange={() => onArrangementChange('custom')}
            />
            <span className="option-text">Configurare personalizată</span>
          </label>
        )}
      </div>
    </div>
  );
};

export default SpatialConfig;